<div class="responsive-card d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-2">
    <div class="responsive-card-title" i18n>Supporting Documents</div>
    <div *ngIf="receivedDate" class="received-date" i18n>
      Document(s) received on {{ receivedDate | date : 'longDate' }}
    </div>
  </div>
  <div class="d-flex flex-column gap-3">
    <div class="file-list-label" i18n>Submitted Files</div>
    <app-file-list-item
      *ngFor="let file of files; trackBy: trackById"
      [fileName]="file.attachment.fileName"
      [fileSizeInBytes]="file.attachment.fileSize"
      [previewUrl]="file.attachment | presignedUrl"
      action="download"
      (downloadClicked)="fileDownloadService.downloadAttachment(file.attachment)"
      class="w-100" />
  </div>
</div>
